import verificationImage from "../../assets/mobile.webp";

const checks = [
  {
    title: "Mobile match",
    description:
      "Confirms the number belongs to the borrower, not the agent.",
  },
  {
    title: "Name match",
    description:
      "Stops KYC mismatches that surface later and kill the file.",
  },
  {
    title: "UPI/VPA confirmation",
    description:
      "Ties a real bank account to the applicant.",
  },
  {
    title: "Timestamped log",
    description:
      "Every check has a time and a result, kept against the lead ID.",
  },
];

function VerificationDetail() {
  return (
    <section className="overflow-hidden  section-spacing">
      <div className="section-container grid grid-cols-1 items-center gap-10 md:gap-14 lg:grid-cols-[0.7fr_1.3fr] lg:gap-20">

        {/* ================= IMAGE ================= */}
        <div className="flex items-center justify-center lg:justify-start">
          <img
            src={verificationImage}
            alt="Verification document and mobile check"
            className="w-[190px] object-contain sm:w-[220px] lg:w-[235px]"
            loading="lazy"
            decoding="async"
          />
        </div>

        {/* ================= CONTENT ================= */}
        <div>
          {/* Label */}
          <p className="font-jakarta text-[11px] sm:text-[12px] font-medium tracking-[0.34em] text-[var(--hero-green)] uppercase mb-2.5">
            VERIFICATION, IN DETAIL
          </p>

          {/* Heading */}
          <h2 className="mt-3 font-bricolage text-[30px] sm:text-[34px] md:text-[38px] lg:text-[40px] font-bold leading-[1.12] tracking-[-1px] text-[#111827]">
            Clean files before a lender opens them.
          </h2>

          {/* Checks */}
          <ul className="mt-6 space-y-4 sm:mt-7 sm:space-y-4">
            {checks.map((check) => (
              <li
                key={check.title}
                className="flex items-start gap-2.5 font-jakarta text-[12px] leading-[1.55] text-[#56636a] sm:text-[13px] md:text-[14px]"
              >
                {/* Check */}
                <span
                  aria-hidden="true"
                  className="mt-[1px] shrink-0 text-[var(--mint-green)]"
                >
                  ✓
                </span>

                {/* Text */}
                <p>
                  <span className="font-semibold text-[#10191c]">
                    {check.title}
                  </span>

                  <span className="text-[#7a8589]">
                    {" "}
                    — {check.description}
                  </span>
                </p>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}

export default VerificationDetail;